import { DESTINATION_PROP_TYPES } from "@constants/places/proptypes";

export function Overview({ intro }) {
  return (
    <div className="container mt-8 mb-16 lg:mt-16 lg:mb-24 lg:flex lg:justify-between">
      <h2 className="heading-02 mb-6">Overview</h2>
      <div className="hidden w-[1px] mx-24 shrink-0 bg-black-200 lg:flex" />
      {intro && <p className="max-w-3xl leading-loose text-black">{intro}</p>}
    </div>
  );
}

Overview.propTypes = {
  intro: DESTINATION_PROP_TYPES.intro, // eslint-disable-line react/require-default-props
};
